import React, {ReactNode} from 'react';

interface ExternalLinkProps {
    href?: string;
    className?: string;
    /** marks paid links for search engines */
    sponsored?: boolean;
    children: ReactNode;
}

/** Opens `href` in a new tab; without `href` only the content is rendered. */
const ExternalLink = ({href, className, sponsored = false, children}: ExternalLinkProps) => {
    if (!href) {
        return <span className={className}>{children}</span>;
    }
    return sponsored
        ? <a href={href} className={className} target="_blank" rel="noopener noreferrer sponsored">{children}</a>
        : <a href={href} className={className} target="_blank" rel="noopener noreferrer">{children}</a>;
};

export default ExternalLink;
